module.exports = __webpack_public_path__ + "img/kid.c8738549.svg";